export default __webpack_public_path__ + "static/media/Play3.94755870.png";